<div class="faq-icon">
  <button siPreventDoubleClick
          class="si-button_icon-black"
          pTooltip="{{'SI_FAQS' | translate}}"
          tooltipPosition="bottom"
          type="button"
          (click)="onClickButtonFAQ()">
    <i class="icosun-help_circle"></i>
  </button>
</div>
